import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
export function DifferenceSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-137" data-mp="3dq8rf4bf9tlz">
      <SectionHeading eyebrow="What will make the difference in your consultation?" title={<>
            The way you organize information <em className="text-rose" data-id="element-139" data-mp="3njpk24ztp2o2">matters, too.</em>
          </>} data-id="element-138" data-mp="3iiiac0e4dter" />
      <div className="mx-auto mt-8 max-w-2xl space-y-5 text-[17px] leading-relaxed text-ink/85" data-id="element-140" data-mp="2pvxjr25gxlc9">
        <p data-id="element-141" data-mp="2utfv0z6ykcnf">
          Menopause care requires clinical knowledge, individualized assessment, and the ability to navigate information
          thoughtfully. I created Menopause Decision Map™ to help physicians bring more structure to that process.
        </p>
        <p data-id="element-142" data-mp="f2uprdx3cqll">
          The six volumes provide a visual framework for organizing assessment questions, reviewing relevant
          considerations, documenting clinical reasoning, and preparing follow-up conversations.
        </p>
        <p data-id="element-143" data-mp="ddph3kindpeq">The goal isn't to replace experience or judgment. It's to provide practical resources you can adapt to your own way of working.</p>
        <p className="rounded-2xl bg-blush p-5 font-serif text-xl font-semibold leading-snug text-plum" data-id="element-144" data-mp="4darwa2kbq5y">
          Imagine having your assessment maps, checklists, and consultation templates organized in one place instead of
          repeatedly searching through scattered notes.
        </p>
      </div>
      <CtaButton className="mt-10" label="I want the complete collection" data-id="element-145" data-mp="3luaqv3j3smiw" />
    </section>;
}